
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { ExtractImagesFromXDTopSection } from "@/sections/ExtractImagesFromXDTopSection";
import { ExtractImagesFromXDFeaturesSection } from "@/sections/ExtractImagesFromXDFeaturesSection";
import { ExtractImagesFromXDHowItWorksSection } from "@/sections/ExtractImagesFromXDHowItWorksSection";

const ExtractImagesFromXd = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/ExtractImagesFromXD"
        ogImage="/images/extract-images-from-xd-og-image.jpg"
      />

      <ExtractImagesFromXDTopSection
        title={t("page/ExtractImagesFromXD:title")}
        subtitle={t("page/ExtractImagesFromXD:subtitle")}
        betaFormSubtitle={t(
          "page/ExtractImagesFromXD:section/top.betaFormSubtitle",
        )}
      />

      <ExtractImagesFromXDFeaturesSection
        title={t("page/ExtractImagesFromXD:section/features.title")}
        items={[
          {
            icon: "NEW-PNG-FILE-ICON",
            iconColor: "#37C2DA",
            title: t(
              "page/ExtractImagesFromXD:section/features.items.png.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/features.items.png.description",
            ),
          },
          {
            icon: "NEW-JPG-FILE-ICON",
            iconColor: "#6179FF",
            title: t(
              "page/ExtractImagesFromXD:section/features.items.jpg.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/features.items.jpg.description",
            ),
          },
          {
            icon: "NEW-PDF-FILE-ICON",
            iconColor: "#FF5A60",
            title: t(
              "page/ExtractImagesFromXD:section/features.items.pdf.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/features.items.pdf.description",
            ),
          },
        ]}
      />

      <ExtractImagesFromXDHowItWorksSection
        title={t("page/ExtractImagesFromXD:section/how-it-works.title")}
        description={t(
          "page/ExtractImagesFromXD:section/how-it-works.description",
        )}
        items={[
          {
            rightSidedImage: true,
            title: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.upload.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.upload.description",
            ),
            icon: "NEW-LOCK-ICON",
            iconColor: "#6179FF",
            image: {
              src: "/images/extract-images-from-xd-file-upload.jpg",
              alt: "upload",
            },
            button: {
              label: t(
                "page/ExtractImagesFromXD:section/how-it-works.items.upload.button",
              ),
              href: "#MagiciansSection",
            },
          },
          {
            title: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.extract.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.extract.description",
            ),
            icon: "SETTINGS-ICON",
            iconColor: "#7427EF",
            image: {
              src: "/images/extract-images-from-xd-extracting.jpg",
              alt: "upload",
            },
            button: {
              label: t(
                "page/ExtractImagesFromXD:section/how-it-works.items.extract.button",
              ),
              href: "#MagiciansSection",
            },
          },
          {
            rightSidedImage: true,
            title: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.download.title",
            ),
            description: t(
              "page/ExtractImagesFromXD:section/how-it-works.items.download.description",
            ),
            icon: "NEW-PNG-FILE-ICON",
            iconColor: "#37C2DA",
            image: {
              src: "/images/extract-images-from-xd-download.jpg",
              alt: "upload",
            },
            button: {
              label: t(
                "page/ExtractImagesFromXD:section/how-it-works.items.extract.button",
              ),
              href: "#MagiciansSection",
            },
          },
        ]}
      />
    </>
  );
};

export default ExtractImagesFromXd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/extract-images-from-xd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  